// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"125":"7d134f7a64e49d284d8b","223":"8abf7697e605a39574dd","293":"7a7af9f7db3c61477d3b","385":"740faad262f33f38f553"}[chunkId] + ".js";
};